import { render } from "./HandbookArticleCreate.vue?vue&type=template&id=567b9072&scoped=true"
import script from "./HandbookArticleCreate.vue?vue&type=script&lang=js"
export * from "./HandbookArticleCreate.vue?vue&type=script&lang=js"

import "./HandbookArticleCreate.vue?vue&type=style&index=0&id=567b9072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567b9072"]])

export default __exports__